// localStorage wrapper that never throws (private mode / blocked storage).
export const safeStorage = {
  get(key) { try { return window.localStorage.getItem(key); } catch { return null; } },
  set(key, value) { try { window.localStorage.setItem(key, value); } catch { /* storage blocked */ } },
  remove(key) { try { window.localStorage.removeItem(key); } catch { /* storage blocked */ } },
};
